import React from "react";

const EvidenceSection = ({ language }) => {
  const isEnglish = language === "en";

  const comparisonSrc = isEnglish
    ? `${process.env.PUBLIC_URL}/images/ImagenesWebHome/Comparisons.png`
    : `${process.env.PUBLIC_URL}/images/ImagenesWebHome/Comparativos.png`;

  const flowchartSrc = isEnglish
    ? `${process.env.PUBLIC_URL}/images/ImagenesWebHome/FlowChart.png`
    : `${process.env.PUBLIC_URL}/images/ImagenesWebHome/DiagramaFlujo.png`;

  return (
    <section className="security-evidence anim-section home-section" id="evidencia">
      <div className="home-container">
        <div className="section-head evidence-head">
          <h2>
            {language === "es"
              ? "Validación de seguridad y evidencia digital"
              : "Security validation and digital evidence"}
          </h2>
          <p>
            {language === "es"
              ? "Validación de seguridad y evidencia digital a lo largo del proceso logístico. Cada etapa suma señales (IoT + visual + operativas) para detectar riesgos y certificar integridad."
              : "Security validation and digital evidence across the logistics process. Each stage adds signals (IoT + visual + operational) to detect risks and certify integrity."}
          </p>
        </div>

        <div className="evidence-steps">
          <button className="evidence-step active" type="button">
            {language === "es" ? "1 Salida de planta" : "1 Plant departure"}
          </button>
          <button className="evidence-step" type="button">
            {language === "es" ? "2 Inspecciones en ruta" : "2 En-route inspections"}
          </button>
          <button className="evidence-step" type="button">
            {language === "es" ? "3 Ingreso a puerto" : "3 Port entry"}
          </button>
          <button className="evidence-step" type="button">
            {language === "es" ? "4 Recepción cliente" : "4 Customer reception"}
          </button>
        </div>

        <div className="evidence-meta">
          <span>{language === "es" ? "Token / evidencia" : "Token / evidence"}</span>
          <span>{language === "es" ? "Georreferencia" : "Georeference"}</span>
          <span>Timestamp</span>
          <span>{language === "es" ? "Auditoría" : "Audit"}</span>
        </div>

        <div className="evidence-panels">
          <div className="evidence-panel">
            <h4>
              {language === "es"
                ? "Diagrama de flujo (APP Valitronics + IA Visual Logistics)"
                : "flow diagram (APP Valitronics + IA Visual Logistics)"}
            </h4>
            <img
              className="evidence-placeholder"
              src={flowchartSrc}
              alt={isEnglish ? "Flow chart" : "Diagrama de flujo"}
              loading="lazy"
            />
          </div>
          <div className="evidence-panel">
            <h4>
              {language === "es"
                ? "Comparativos visuales (precintos / etiquetas) + alertas"
                : "Visual comparisons (seals / labels) + alerts"}
            </h4>
            <img
              className="evidence-placeholder"
              src={comparisonSrc}
              alt={isEnglish ? "Visual comparisons" : "Comparativos visuales"}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EvidenceSection;
